export const FORMA_DE_COBRO = {
  TRANSFERENCIA: 1,
  PAGARE: 2,
  CONFIRMING: 3,
  PAGO_DOMICILIADO: 4,
} as const

export type FormaDeCobroType =
  (typeof FORMA_DE_COBRO)[keyof typeof FORMA_DE_COBRO]
